import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const ModalInterestedForm = () => {
  const navigate = useNavigate();
  return (
    <dialog id="register_modal" className="modal shadow-2xl">
      <div className="modal-box flex flex-col justify-between max-w-none w-full md:w-[500px] p-10 gap-4 h-fit items-center">
        <div className="flex flex-col gap-5 font-bold text-[16px]">
          Thinking about giving Nitomeyo a try?
        </div>

        <div className="flex flex-row justify-center gap-10">
          <div
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("register_modal").close();
            }}
            className="flex flex-col border border-primary text-primary rounded-lg hover:bg-gray-100 cursor-pointer px-10 py-2"
          >
            No
          </div>
          <div
            onClick={(e) => {
              e.preventDefault();
              navigate("/register");
            }}
            className={`flex flex-col text-white rounded-lg bg-primary hover:bg-tertiary cursor-pointer px-10 py-2`}
          >
            Yes
          </div>
        </div>
      </div>
      <form method="dialog" className="modal-backdrop">
        <button>close</button>
      </form>
    </dialog>
  );
};

export default ModalInterestedForm;
